import { schemeBlues } from "d3"

export const kDefaultLowAttributeColor = schemeBlues[5][0]
export const kDefaultHighAttributeColor = schemeBlues[5][4]
